module.exports = __webpack_public_path__ + "static/media/specialMeal.b20afccf.svg";